import React from 'react';
import { Button } from '../../components/ui/button';
import { AlertCircle, CheckCircle2, Loader2, Trophy, Target, ShoppingCart, Crown, Swords, Briefcase, Gift, Smartphone } from 'lucide-react';

const WinnersBanner = ({
  setShowWinnersBanner,
  showWinnersBanner,
  winners,
}) => {
  return (
    <>
      {showWinnersBanner && (
        <div className="fixed inset-0 z-[200] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4" onClick={() => setShowWinnersBanner(false)}>
          <div className="max-w-4xl w-full bg-white rounded-lg shadow-2xl overflow-y-auto max-h-[90vh]" onClick={(e) => e.stopPropagation()} role="dialog" aria-labelledby="winners-title">
            <div className="text-center py-6 px-4">
              <div className="flex items-center justify-center gap-3 mb-4">
                <Crown className="h-10 w-10 text-yellow-600" />
                <h2 id="winners-title" className="text-3xl font-bold text-yellow-700">
                  TOP 3 DA SEMANA
                </h2>
                <Crown className="h-10 w-10 text-yellow-600" />
              </div>
              
              <div className="grid md:grid-cols-2 gap-6 mt-6">
                {/* TOP 3 AGENTES */}
                <div className="bg-gradient-to-br from-purple-500 to-blue-500 text-white rounded-lg p-4">
                  <h3 className="text-xl font-bold mb-3">💼 TOP AGENTES AFILIADOS</h3>
                  <div className="space-y-2">
                    {winners.agentes.length === 0 ? (
                      <p className="text-sm opacity-80">Nenhum agente esta semana</p>
                    ) : (
                      winners.agentes.map((w) => (
                        <div key={w.id} className={`flex items-center gap-3 p-3 rounded ${
                          w.position === 1 ? 'bg-yellow-400 text-gray-900' :
                          w.position === 2 ? 'bg-gray-300 text-gray-900' :
                          'bg-orange-300 text-gray-900'
                        }`}>
                          <span className="text-3xl">
                            {w.position === 1 && '🥇'}
                            {w.position === 2 && '🥈'}
                            {w.position === 3 && '🥉'}
                          </span>
                          {w.kako_avatar && (
                            <img src={w.kako_avatar} alt="" className="w-12 h-12 rounded-full border-2 border-white" />
                          )}
                          <div className="flex-1 text-left">
                            <div className="font-bold">{w.nickname}</div>
                            <div className="text-sm">{w.week_coins.toLocaleString()} 🪙</div>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </div>

                {/* TOP 3 HOSTS */}
                <div className="bg-gradient-to-br from-pink-500 to-red-500 text-white rounded-lg p-4">
                  <h3 className="text-xl font-bold mb-3">🎭 TOP HOSTS AFILIADOS</h3>
                  <div className="space-y-2">
                    {winners.hosts.length === 0 ? (
                      <p className="text-sm opacity-80">Nenhum host esta semana</p>
                    ) : (
                      winners.hosts.map((w) => (
                        <div key={w.id} className={`flex items-center gap-3 p-3 rounded ${
                          w.position === 1 ? 'bg-yellow-400 text-gray-900' :
                          w.position === 2 ? 'bg-gray-300 text-gray-900' :
                          'bg-orange-300 text-gray-900'
                        }`}>
                          <span className="text-3xl">
                            {w.position === 1 && '🥇'}
                            {w.position === 2 && '🥈'}
                            {w.position === 3 && '🥉'}
                          </span>
                          {w.kako_avatar && (
                            <img src={w.kako_avatar} alt="" className="w-12 h-12 rounded-full border-2 border-white" />
                          )}
                          <div className="flex-1 text-left">
                            <div className="font-bold">{w.nickname}</div>
                            <div className="text-sm">{w.week_coins.toLocaleString()} 🪙</div>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              </div>

              <Button
                onClick={() => setShowWinnersBanner(false)}
                className="mt-6 w-full bg-purple-600 hover:bg-purple-700"
              >
                Fechar
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WinnersBanner;
